<template>
  <div class="field">
    <div v-if="hasImage" class="flex items-center">
      <img :src="template.logo" style="max-width: 50%; max-height: 150px;">
      <DeleteButton class="ml-3" @click="removeImage" />
    </div>
    <div v-else class="flex items-center">
      <span v-if="loading" class="py-6 flex items-center w-full">
          <loader class="text-80" width="32" />
      </span>
      <span v-else class="form-file">
        <input
          id="logo"
          ref="fileField"
          class="form-file-input"
          accept="image/*"
          type="file"
          @change="loadImage"
        >
        <label for="logo" class="inline-block font-semibold text-primary py-6">
            {{ $t('Upload logo') }}
        </label>
      </span>
    </div>
  </div>
</template>

<script>
  import PhotoReader from '@/_legacy/util/PhotoReader';
  import DeleteButton from '@/_legacy/components/DeleteButton.vue';
  import { EVENTS, EventTypes, trackEvent } from '@/services/activityTracker/activityTrackerHelper';

  // todo: change to work with Assets later
  export default {
    components: { DeleteButton },
    props: {
      template: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      loading: false,
    }),
    computed: {
      hasImage() {
        return !!this.template.logo;
      },
    },
    methods: {
      loadImage() {
        trackEvent(EventTypes.imageUpload, EVENTS.LOGO_UPLOAD);
        this.loading = true;
        const file = this.$refs.fileField.files[0];
        PhotoReader.read(file, 800)
          .then(({ photo }) => {
            this.template.logo = photo;
            this.loading = false;
          });
      },
      removeImage() {
        this.loading = false;
        this.template.logo = null;
      },
    },
  };
</script>
